import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Center,
  ScrollView,
  Button,
  useToast,
  Stack,
  FlatList,
  FormControl,
  Avatar,
  Input,
  Icon,
  IconButton,
  StatusBar,
  Heading,
  Select,
  Spacer,
  Tooltip,
  Image,
  Menu,
  Divider,
  Spinner,
  Modal,
  Checkbox,
  ChevronUpIcon,
} from "native-base";

import { GlobalStyles } from "../../constants/styles";
import TicksView from "../../components/TicksView";
import { GlobalConstants } from "../../constants/constants";
import { useNavigation,useRoute } from "@react-navigation/native";
import Toast from "../../components/Toast";
import { useSelector ,useDispatch} from "react-redux";
import axios from "axios";
import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import { Pressable } from "react-native";
import LoadFonts from "../../components/LoadFonts";
import FeedCardForCitizen from "../../components/FeedCardForCitizen";
import AdCardForCitizen from "../../components/AdCardForCitizen.js";
import AdProductCardForBusiness from "../../components/AdProductCardForBusiness";
import { StyleSheet } from "react-native";
import SetUser from "../../redux/user/SetUser";
import { validEmail } from "../../utils/general";
import { flushSync } from 'react-dom';

const CitizenMainPage = () => {
  const dispatch = useDispatch();
  // let user = useSelector((state) => state.user.user);
  let user = useSelector((state) => state.user.user);
  axios.defaults.headers.common = {
    Authorization: `bearer ${user ? user.token : null}`,
  };

  const toast = useToast();
  const navigation = useNavigation();
  const route = useRoute();

  const [cityGovBtnTextColor, setCityGovBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [businessBtnTextColor, setBusinessBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [eventsBtnTextColor, setEventsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [openingsBtnTextColor, setOpeningsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [dealsBtnTextColor, setDealsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [adsBtnTextColor, setAdsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );
   const [cityLensBtnTextColor, setCityLensBtnTextColor] = useState(
    GlobalStyles.colors.white
  );
  const [productsBtnTextColor, setProductsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [savedBtnTextColor, setSavedBtnTextColor] = useState(
    GlobalStyles.colors.white
  );
  const [sharedBtnTextColor, setSharedBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [ticks, setTicks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(false);

  const [isEventsEnabled, setIsEventsEnabled] = useState(true);
  const [isOpeningsEnabled, setIsOpeningsEnabled] = useState(true);
  const [isDealsEnabled, setIsDealsEnabled] = useState(true);

  const [isShowEventsText, setIsShowEventsText] = useState(false);

  const [selectedPost, setSelectedPost] = useState({});
  const [feedType, setFeedType] = useState(0);
  const [friends, setFriends] = useState([]);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [page, setPage] = useState();
  const [isSavedFeeds, setIsSavedFeeds] = useState(false);
  const [isShareFeeds, setIsShareFeeds] = useState(false);
 
  const initialRef = useRef(null);
  const finalRef = useRef(null);
  const [activeButton, setActiveButton] = useState("");
  const [subActiveButton, setSubActiveButton] = useState("");
  const [topActiveButton, setTopActiveButton] = useState("");
  ///// Search and Follow Business////////////
  const [noSearchBusinessResultText, setNoSearchBusinessResultText] =
  useState("");
  const [unfollowBusinesses, setUnfollowBusinesses] = useState([]);
  const [businessSelectedId, setBusinessSelectedId] = useState();
  const [followedBusinesses, setFollowedBusinesses] = useState([]);
  const [isFollowedBusinessSelected, setIsFollowedBusinessSelected] =
    useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isDropdownFilter, setIsDropdownFilter] = useState(false);

  const [businessCategories, setBusinessCategories] = useState([]);
  const [businessSubCategories, setBusinessSubCategories] = useState([]);
  // const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0);

  const [selectedCategory, setSelectedCategories] = useState("");
  const [selectedSubCategory, setSelectedSubCategories] = useState("");  
  const [isShowInvite, setIsShowInvite] = useState(false); 
  const [isShowProducts, setIsShowProducts] = useState(false); 
  const [inviteEmail, setInviteEmail] = useState("");
  const [isInviteSending, setIsInviteSending] = useState(false);
  const [invitedFriends, setInvitedFriends] = useState([]);
  /// Ads states ////////
  const [isAdsEnable, setIsAdsEnable] = useState(false);
  const [selectedIndexAd, setSelectedIndexAd] = useState(0);
  const [adType, setAdType] = useState(0);
  const [adsCat, setAdsCat] = useState([]);
  const isAdsEnableRef = useRef(isAdsEnable);
  const [isBrand, setIsBrand] = useState("LOCAL");
  const [categoryKey, setCategoryKey] = useState("category");
 const [subCategoryKey, setSubCategoryKey] = useState("sub-category");
 const [shareCount, setShareCount] = useState();
 /// for data show from start ///
 const [categories, setCategories] = useState([]); // list of category names
const [subCategories, setSubCategories] = useState([]); // current subcategories
const [selectedCategoryCheck, setSelectedCategoryCheck] = useState(null); // selected category
const [selectedSubCategoriesCheck, setSelectedSubCategoriesCheck] = useState([]); // selected subcategories
const [selectedCombinations, setSelectedCombinations] = useState([]); // category-subcategory combinations
const [fullCategoriesData, setFullCategoriesData] = useState([]);
const [productPosts,setProductPosts]=useState([]);
const [hasMorePosts, setHasMorePosts] = useState(true);
const [isProductView, setIsProductView] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
const [isLoadingMore, setIsLoadingMore] = useState(false);
const [activeTab, setActiveTab] = useState("popular");
const [isLoadingProducts,setIsLoadingProducts]=useState(false);
  const windowWidth = window?.innerWidth || 400;

 const [showSelects, setShowSelects] = useState(true); // optional
  const buttonData = [
    { label: "Product/Service", icon: require("../../../assets/prouctAct.png") ,id:1 },
    { label: "Brand/Design", icon: require("../../../assets/BrandDesign.png") ,id:6},
    { label: "Informative", icon: require("../../../assets/informative.png") ,id:2},
    { label: "Public Service", icon: require("../../../assets/publicService.png"),id:3 },
    { label: "Political", icon: require("../../../assets/political.png") ,id:4},
    { label: "Others", icon: require("../../../assets/others.png") ,id:7},
  ];
  //// for text on editor of right hand ///////
  const [textModeForEditor, setTextModeForEditor] = useState("Share important Gov Announcements with your friends and family, on TownTicks.");

  function changeColor(btnType) {
    if (btnType === "Business") {
      setBusinessBtnTextColor(GlobalStyles.colors.mustard);
      setCityGovBtnTextColor(GlobalStyles.colors.blue);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
    } else if (btnType === "CityGov") {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.mustard);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
    } else if (btnType === "Events") {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.blue);
      setEventsBtnTextColor(GlobalStyles.colors.mustard);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(true);
    } else if (btnType === "Openings") {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.blue);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.mustard);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
    } else if (btnType === "Deals") {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.blue);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.mustard);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
      // setIsAdsEnable(false);
    } else if (btnType === "Ads") {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.blue);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.mustard);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
    }else if (btnType === "Products") {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.blue);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.mustard);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
    }else if (btnType === "cityLens") {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.blue);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.mustard);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
    } else if (btnType === "Saved") {
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.mustard);
    } else if (btnType === "Shared") {
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.mustard);
    } else {
      setBusinessBtnTextColor(GlobalStyles.colors.blue);
      setCityGovBtnTextColor(GlobalStyles.colors.mustard);
      setEventsBtnTextColor(GlobalStyles.colors.blue);
      setOpeningsBtnTextColor(GlobalStyles.colors.blue);
      setAdsBtnTextColor(GlobalStyles.colors.blue);
      setCityLensBtnTextColor(GlobalStyles.colors.blue);
      setProductsBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setSavedBtnTextColor(GlobalStyles.colors.blue);
      setSharedBtnTextColor(GlobalStyles.colors.blue);
      setIsShowEventsText(false);
    }
  }

  const getSettings = async () => {
    if (user.user_category == GlobalConstants.userCategories.citizen.id) {
      try {
        const resp = await axios.get(
          `${GlobalConstants.townTicksBaseUrl}users/settings`
        );
        if (resp.data.status) {
          setIsEventsEnabled(resp.data.data.is_events_display);
          setIsOpeningsEnabled(resp.data.data.is_openings_display);
          setIsDealsEnabled(resp.data.data.is_deals_display);
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={"Failed to get settings!!!"}
                />
              );
            },
            placement: "top",
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const feedsFirstPage = async (type) => {
    setIsSavedFeeds(false);
    setIsShareFeeds(false);
    setIsFollowedBusinessSelected(false);
    setIsShowInvite(false);
    setIsShowProducts(false);
    setSubActiveButton("");
    setTicks([]);
    setIsLoading(true);
    // setAdType(0);
    setFeedType(type);
    setIsAdsEnable(false); // async state update
    isAdsEnableRef.current = false; // 👈 immediate sync update
    setIsAdsEnable(isAdsEnableRef.current);
    console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
    const data = await  getTicksByTypeId(type, 1);
    console.log(data,"data fetch")
    await getShareCount(type);
    setTicks(data);
    scrollToTop();
    setPage(2);
    setIsAdsEnable(false);
    setIsLoading(false);
  };

  const feedsNextPage = async () => {
    setIsLoadMoreLoading(true);
    let data = await   getTicksByTypeId(feedType, page);
    setTicks([...ticks, ...data]);
    setPage(page + 1);
    setIsLoadMoreLoading(false);
  };

  const getTicksByTypeId = async (type, page, offSet = 10) => {
    try {
      // setIsAdsEnable(false);
      // console.log("data test",isAdsEnable)
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}v1/users/feed?type=` +
          type +
          `&page=` +
          page +
          `&limit=` +
          offSet
      );
      if (resp.data.status) {
        var data = resp.data.data;
        data.forEach((element) => {
          element.savedAllowed = true;
        });

        if (data.length == offSet) {
          setShowLoadMore(true);
        } else {
          setShowLoadMore(false);
        }
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  

   //////Ads functions //////////
   const adsFirstPage = async (type) => {
    setIsSavedFeeds(false);
    setIsShareFeeds(false);
    setIsFollowedBusinessSelected(false);
    setIsShowInvite(false);
    setIsShowProducts(false);
    // setIsAdsEnable(true);
  isAdsEnableRef.current = true; // 👈 instant update
  setIsAdsEnable(isAdsEnableRef.current);
  console.log("Ads triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
    setSubActiveButton("");
    setTicks([]);
    setIsLoading(true);
    console.log("id",type,isAdsEnable)
    
    const data = await  getSpecialTicks(type,1);
    await getShareCount(type);
    setAdType(type);
    console.log("data",data)
    setTicks(data);
    setPage(2);
    setIsAdsEnable(true);
    setIsLoading(false);
  };
   const getSpecialTicks = async (type, page, offSet = 10) => {
    try {
      
      
      console.log("enter hit",type,isAdsEnable)
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}ad/category/${type}?page=` +
          page +
          `&limit=` +
          offSet
      );
      if (resp.data.status) {
        var data = resp.data.data;
        data.forEach((element) => {
          element.savedAllowed = true;
        });

        if (data.length == offSet) {
          setShowLoadMore(true);
        } else {
          setShowLoadMore(false);
        }
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const adsNextPage = async () => {
    setIsLoadMoreLoading(true);
    let data = await  getSpecialTicks(adType, page);
    setTicks([...ticks, ...data]);
    setPage(page + 1);
    setIsLoadMoreLoading(false);
  };
  useEffect(() => {
    isAdsEnableRef.current = isAdsEnable;
  }, [isAdsEnable]);

  const onClick = async (data) => {
    console.log(data);
    setSelectedPost(data);
    if (data.is_saved) {
      await unSavePost(data.id);
    } else {
      await savePost(data.id);
    }
    if (savedBtnTextColor == GlobalStyles.colors.mustard) {
      await getSavedPost(false);
    }
  };

  const savePost = async (postId) => {
    try {
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}posts/save`,
        {
          post_id: postId,
        }
      );
      if (resp.data.status) {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.green}
                message={"Post saved successfully!!!"}
              />
            );
          },
          placement: "top",
        });
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={"Failed to save post!!!"}
              />
            );
          },
          placement: "top",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const unSavePost = async (postId) => {
    try {
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}posts/unsave`,
        {
          post_id: postId,
        }
      );
      if (resp.data.status) {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.green}
                message={"Post unsaved successfully!!!"}
              />
            );
          },
          placement: "top",
        });
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={"Failed to unsave post!!!"}
              />
            );
          },
          placement: "top",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSavedPost = async (isLoading = true) => {
    setIsSavedFeeds(true);
    setIsLoading(isLoading);
    setIsFollowedBusinessSelected(false);
    setIsShowInvite(false);
    setIsShowProducts(false);
    setActiveButton("");
    isAdsEnableRef.current = false; // 👈 immediate sync update
    setIsAdsEnable(isAdsEnableRef.current);
    console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
    setIsAdsEnable(false);
    setTicks([]);
    try {
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}v1/users/saved-feed?type=` +
          feedType
      );
      if (resp.data.status) {
        var feedArray = resp.data.data;
        feedArray.forEach((element) => {
          element.is_saved = true;
          element.savedAllowed = true;
        });
        setTicks(feedArray);
        setIsLoading(false);
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSharedPost = async (isLoading = true) => {
    setIsShareFeeds(true);
    setIsLoading(false);
    setIsLoading(isLoading);
    setIsFollowedBusinessSelected(false);
    setIsShowInvite(false);
    setIsShowProducts(false);
    setActiveButton("");
    isAdsEnableRef.current = false; // 👈 immediate sync update
    setIsAdsEnable(isAdsEnableRef.current);
    console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
    setIsAdsEnable(false);
    setTicks([]);
    try {
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}friend/shared/post?type=` + feedType
      );
      if (resp.data.status) {
        var feedArray = resp.data.data;
        feedArray.forEach((element) => {
          element.savedAllowed = true;
        });
        setTicks(feedArray);
        setIsLoading(false);
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  // For Counter of shares only

  const getShareCount = async (feedType) => {
    // console.log("Share friends start",feedType)
    try {
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}friend/shared/post?type=` + feedType
      );
      if (resp.data.status) {
        // console.log("Share friends mid")
        const countShare = resp.data.new_post_counter;
        setShareCount(countShare);
        // console.log("Share friends", shareCount, countShare)
        
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (shareCount >= 0) {
      console.log("Share count updated to:", shareCount);
    }
  }, [shareCount]);

  const getSeenShare= async() =>{
 
    try {
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}friend/post/seen`
      );
      if (resp.data.status) {
        
        console.log(resp.data.status_msg)
        
      } else {
      }
    } catch (error) {
      console.log(error);
    }
   
  };

  const getFriends = async () => {
    if (user.user_category == GlobalConstants.userCategories.citizen.id) {
      try {
        const resp = await axios.get(
          `${GlobalConstants.townTicksBaseUrl}/friend`
        );
        if (resp.data.status) {
          setFriends(resp.data.data);
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={"Failed to get Invited Friends!!!"}
                />
              );
            },
            placement: "top",
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const menuItems = [
    { name: "Saved Ticks", icon: require("../../../assets/side-bar-icons/saved.png"), action: () => getSavedPost()  },
    { name: "Friend's Shares", icon: require("../../../assets/side-bar-icons/shared.png"), action: () => {getSharedPost();getSeenShare();} },
    { name: "Follow Business", icon: require("../../../assets/side-bar-icons/business.png"),  action: () => unfollowBusinessesPage1("LOCAL") },
    { name: "Invite Friends", icon: require("../../../assets/side-bar-icons/inviteFriend.png"), action: () => handleShowInvite() },

  ];
  const handlePress = (name, action) => {
    // setActive(name); 
    console.log(name,"print")
    setSubActiveButton(name);
    changeColor(name);// Change active state
    action(); // Execute the dynamic function
  };
  const styles = StyleSheet.create({
    textWithShadow: {
      fontSize: 30,
      color: GlobalStyles.colors.mustard,
      fontFamily: GlobalStyles.text.fontFamily,
      textShadowColor: "#585858",
      textShadowOffset: { width: 1, height: 1 },
      textShadowRadius: 0,
    },
    textWithShadowMobile: {
      fontSize: 15,
      color: GlobalStyles.colors.mustard,
      fontFamily: GlobalStyles.text.fontFamily,
      textShadowColor: "#585858",
      textShadowOffset: { width: 1, height: 1 },
      textShadowRadius: 0,
    },
  });
  const [modalVisible, setModalVisible] = useState(false);

  ////// for scroll up to the top //////
  const scrollViewRef = useRef(null);
  const [showUpButton, setShowUpButton] = useState(false);
  const scrollY = useRef(0);
  const scrollToTop = () => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ y: 0, animated: true });
    }
  };
  const handleScroll = (event) => {
    const scrollY = event.nativeEvent.contentOffset.y;
    setShowUpButton(scrollY > 100); // Show button when user scrolls down 100px
  };
  // Function to Fetch Followed Businesses
  function getAvatarChar(fullName) {
    let nameShortCode = "";
    if (fullName && fullName.split(" ").length > 1) {
      nameShortCode =
        fullName.split(" ")[0].charAt(0).toUpperCase() +
        fullName.split(" ")[1].charAt(0).toUpperCase();
    } else {
      nameShortCode = fullName.charAt(0).toUpperCase();
    }
    return nameShortCode;
  }
  const getFollowedBusinesses = async () => {
      setIsFollowedBusinessSelected(true);
      setIsLoading(true);
      setShowLoadMore(false);
      setIsShowEventsText(false);
      setIsShowInvite(false);
      setIsShowProducts(false);
      setActiveButton("");
      setTicks([]);
      isAdsEnableRef.current = false; // 👈 immediate sync update
      setIsAdsEnable(isAdsEnableRef.current);
      console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
      setIsAdsEnable(false);
      
      // setIsFollowedBusinessSelected(false)
    };
    const renderUnfollowBusinessesFooter = () => {
      return (
        //Footer View with Load More button
        
        <Box alignItems="center">
          {isDropdownFilter ? (
            <></>
          ) : isSearching ? (
            <></>
          ) : showLoadMore ?(
            
            <Button
              isLoading={isLoading}
              w="20%"
              h="95%"
              mt={2}
              variant="outline"
              onPress={() => unfollowBusinessesNextPage(isBrand)}
            >
              Load More
            </Button>
          ):(
          <></>
          )}
        </Box>
      );
    };
  
    const unfollowBusinessesNextPage = async (type="LOCAL") => {
      setIsSearching(false);
      setIsLoading(true);
      let data = await getUnfollowBusinesses(page,50,"",type);
      //After the response increasing the offset for the next API call.
      setUnfollowBusinesses([...unfollowBusinesses, ...data]);
      setPage(page + 1);
      setIsLoading(false);
    };
  
    const unfollowBusinessesPage1 = async (type="LOCAL") => {
      setIsFollowedBusinessSelected(true);
      setShowLoadMore(false);
      setIsShowEventsText(false);
      setIsShowInvite(false);
      setIsShowProducts(false);
      setIsDropdownFilter(false);
      setIsBrand(type);
      setActiveButton("");
      setTicks([]);
      setIsSearching(false);
      setIsLoading(true);
      isAdsEnableRef.current = false; // 👈 immediate sync update
      setIsAdsEnable(isAdsEnableRef.current);
      console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
      setIsAdsEnable(false);
      setUnfollowBusinesses([]);
      let data = await getUnfollowBusinesses(1,50,"",type);
      setUnfollowBusinesses(data);
      setPage(2);
      
      setIsLoading(false);
    };
  
    const onSearchTextChange = async (keyword) => {
      if (keyword) {
        setSelectedCategories("");
        setSelectedSubCategories("");
        setIsDropdownFilter(false);
        setBusinessSubCategories([]);
        setIsSearching(true);
        setUnfollowBusinesses([]);
        let data = await getUnfollowBusinesses(1, 100, keyword);
        setUnfollowBusinesses(data);
        if (data.length) {
          setNoSearchBusinessResultText("");
        } else {
          setNoSearchBusinessResultText(
            "Business you are searching is not yet our partner."
          );
        }
      } else {
        await unfollowBusinessesPage1();
      }
    };
  
    const getUnfollowBusinesses = async (page, offSet = 50, text = "",type="LOCAL") => {
      let data = [];
      try {
        const resp = await axios.get(
          `${GlobalConstants.townTicksBaseUrl}businesses?query=` +
            text +
            `&page=` +
            page +
            `&offSet=` +
            offSet +
            `&type=` +
            type 
        );
        
        if (resp.data.status) {
          data = resp.data.data;
          console.log("length",data.length)
        }
        if(data.length == offSet){
          setShowLoadMore(true);
          
        } else {
          setShowLoadMore(false);
        }
        return data;
      } catch (error) {
        console.log(error);
      }
    };
    const getAllBusinessCategories = async (type="LOCAL") => {
      try {
        const resp = await axios.get(
          `${GlobalConstants.townTicksBaseUrl}businesses/category?type=${type}`
        );
        if (resp.data.status) {
          setBusinessCategories(resp.data.data);
          if (type === "INTERNATIONAL") {
            const fixedId = "16"; // as a string, since your Select uses .toString()
            getAllBusinessSubCategoriesById(fixedId);
            setSelectedCategories(fixedId);
          }
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={"Failed to get business categories!!!"}
                />
              );
            },
            placement: "top",
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    const getAllBusinessSubCategoriesById = async (type) => {
      try {
        if (type > 0) {
          setUnfollowBusinesses([]);
          setIsDropdownFilter(true);
          const resp = await axios.get(
            `${GlobalConstants.townTicksBaseUrl}businesses/subcategory/` + type
          );
          if (resp.data.status) {
            setBusinessSubCategories(resp.data.data);
          } else {
            toast.show({
              render: () => {
                return (
                  <Toast
                    color={GlobalStyles.colors.red}
                    message={"Failed to business sub categories!!!"}
                  />
                );
              },
              placement: "top",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    const OnChangeSubCategoryGetUnfollowedBusiness = async (subCategoryId) => {
      try {
        if (subCategoryId > 0) {
          const resp = await axios.get(
            `${GlobalConstants.townTicksBaseUrl}businesses/v1/category/` +
              subCategoryId
          );
          if (resp.data.status) {
            setUnfollowBusinesses(resp.data.data);
            setIsDropdownFilter(true);
          } else {
            setUnfollowBusinesses([]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    const onFollowBusiness = async (id) => {
      try {
        const resp = await axios.post(
          `${GlobalConstants.townTicksBaseUrl}users/follow`,
          {
            following_id: id,
          }
        );
        if (resp.data.status) {
          updateBusinessStateOnFollowUnFollow(id, "follow");
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.green}
                  message={"successfully followed!!!"}
                />
              );
            },
            placement: "top",
          });
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={"Failed to follow business!!!"}
                />
              );
            },
            placement: "top",
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    const onUnfollowBusiness = async (id) => {
      try {
        const resp = await axios.post(
          `${GlobalConstants.townTicksBaseUrl}users/unfollow`,
          {
            following_id: id,
          }
        );
        if (resp.data.status) {
          updateBusinessStateOnFollowUnFollow(id, "unfollow");
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.green}
                  message={"successfully unfollowed!!!"}
                />
              );
            },
            placement: "top",
          });
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={"Failed to unfollow business!!!"}
                />
              );
            },
            placement: "top",
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    const updateBusinessStateOnFollowUnFollow = async (id, type) => {
      let tempBus = [];
      if (type == "follow") {
        tempBus = unfollowBusinesses;
        tempBus = tempBus.filter((obj) => {
          return obj.id !== id;
        });
        setUnfollowBusinesses(tempBus);
        setBusinessSelectedId(id);
      } else {
        tempBus = followedBusinesses;
        tempBus = tempBus.filter((obj) => {
          return obj.id !== id;
        });
        setFollowedBusinesses(tempBus);
        setBusinessSelectedId(id);
      }
    };


    ////////////// end ///////////

    const handleShowInvite = () => {
      setIsFollowedBusinessSelected(false);
      setIsLoading(false);
      setShowLoadMore(false);
      setIsShowEventsText(false)
      setTicks([]);
      setIsShowInvite(true);
      setActiveButton("");
      isAdsEnableRef.current = false; // 👈 immediate sync update
      setIsAdsEnable(isAdsEnableRef.current);
      console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
      setIsAdsEnable(false);
    };
    const SendInvite = async () => {
      setIsInviteSending(true);
      if (inviteEmail) {
        try {
          if (validEmail(inviteEmail)) {
            const resp = await axios.post(
              `${GlobalConstants.townTicksBaseUrl}friend/invite`,
              {
                invitee_email: inviteEmail,
              }
            );
            if (resp.data.status) {
              toast.show({
                render: () => {
                  return (
                    <Toast
                      color={GlobalStyles.colors.green}
                      message={"Invite Sent Successfully!!!"}
                    />
                  );
                },
                placement: "top",
              });
              setInviteEmail("");
              await getInvitedFriends();
            } else {
              toast.show({
                render: () => {
                  return (
                    <Toast
                      color={GlobalStyles.colors.red}
                      message={resp.data.status_msg}
                    />
                  );
                },
                placement: "top",
              });
            }
          } else {
            toast.show({
              render: () => {
                return (
                  <Toast
                    color={GlobalStyles.colors.red}
                    message={"Invalid Email!!!"}
                  />
                );
              },
              placement: "top",
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsInviteSending(false); // Re-enable the button after response is received
        }
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={"Please Enter Email!!!"}
              />
            );
          },
          placement: "top",
        });
      }
    };

    const handleProductView= async() => {
      setIsFollowedBusinessSelected(false);
      setIsLoading(false);
      setShowLoadMore(false);
      setIsShowEventsText(false)
      setTicks([]);
      setIsShowInvite(false);
      setIsAdsEnable(false); // async state update
      isAdsEnableRef.current = false; // 👈 immediate sync update
      setIsAdsEnable(isAdsEnableRef.current);
      console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
      setActiveTab("popular");
      getProductByTagId("popular");
      setIsProductView(true); 
      setIsShowProducts(true);
    }

    const handleShowProducts = () => {
      setIsFollowedBusinessSelected(false);
      setIsLoading(false);
      setShowLoadMore(false);
      setIsShowEventsText(false)
      setTicks([]);
      setIsShowInvite(false);
      setIsAdsEnable(false); // async state update
    isAdsEnableRef.current = false; // 👈 immediate sync update
    setIsAdsEnable(isAdsEnableRef.current);
    console.log("Feeds triggered, isAdsEnable:", isAdsEnableRef.current,isAdsEnable);
      getCategoriesForProduct();
      setIsShowProducts(true);
      setIsProductView(false); 
      scrollToTop();
      // setActiveButton("");
      
    
    }; 
    const handleCheckboxChange = (type, value, checked) => {
      if (type === "category") {
        setSelectedCategoryCheck(value);
        setSelectedSubCategoriesCheck([]);
    
        // children already exist on value
        setSubCategories(value?.children || []);
      } else if (type === "subcategory") {
        let updated = [...selectedSubCategoriesCheck];
        if (checked) {
          updated.push(value);
        } else {
          updated = updated.filter(sub => sub.id !== value.id);
        }
        setSelectedSubCategoriesCheck(updated);
    
        // Update combinations
        const combinations = updated.map(sub => `${selectedCategoryCheck}-${sub}`);
        setSelectedCombinations(combinations);
      }
    };
    const submitSelectedCategories = async (page = 1, reset = false) => {
      setProductPosts([])
      setCurrentPage(1);         
      setHasMorePosts(false); 
      setActiveTab("popular"); 
      const categoryIds = getSelectedCategoryIds();
      if (categoryIds.length === 0) {
        toast.show({
          render: () => <Toast color="red" message="No subcategories selected" />,
          placement: "top",
        });
        return;
      }
      
      try {
        setIsLoadingMore(true);
        const resp = await axios.post(`${GlobalConstants.townTicksBaseUrl}/products/category`, {
          category_ids: categoryIds,
        });
        
        if (resp.data?.status) {
          
          const newPosts = resp.data.data;
  
          setProductPosts((prevPosts) => {
          // Replace list if reset or it's the first page, else append
          return reset || page === 1 ? newPosts : [...prevPosts, ...newPosts];
        });
        if (newPosts.length < 10) {
          setHasMorePosts(false);
        } else {
          setCurrentPage((prev) => (reset ? page + 1 : prev + 1));
        }
          console.log("API response:", resp.data, "re", productPosts);
        } else {
          toast.show({
            render: () => <Toast color="red" message={resp.data?.status_msg || "Failed"} />,
            placement: "top",
          });
        }
      } catch (error) {
        console.log("API error:", error);
        toast.show({
          render: () => <Toast color="red" message="Something went wrong" />,
          placement: "top",
        });
      }
      finally {
        setIsLoadingMore(false); 
      }
    };
    const getSelectedCategoryIds = () => {
      const ids = [];
    
      selectedCombinations.forEach((combo) => {
        const [catName, subName] = combo.split("-");
    
        const catObj = fullCategoriesData.find(c => c.name === catName);
        if (catObj) {
          const subObj = catObj.children.find(sub => sub.name === subName);
          if (subObj) {
            ids.push(subObj.id);
          }
        }
      });
    
      return ids;
    };

    const getProductByTagId = async (tagTitle,page = 1, reset = false) => {
      setProductPosts([])
      setCurrentPage(1);         
      setHasMorePosts(false);  
      setIsLoadingProducts(true);
      console.log("tag title",tagTitle)
      
      try {
        setIsLoadingMore(true);
        const resp = await axios.get(`${GlobalConstants.townTicksBaseUrl}/tags/products?title=${tagTitle}`);
        
        if (resp.data?.status) {
          setIsLoadingProducts(false);
          const newPosts = resp.data.data;
          setProductPosts((prevPosts) => {
          // Replace list if reset or it's the first page, else append
          return reset || page === 1 ? newPosts : [...prevPosts, ...newPosts];
        });
        if (newPosts.length < 10) {
          setHasMorePosts(false);
        } else {
          setCurrentPage((prev) => (reset ? page + 1 : prev + 1));
        }
          console.log("API response:", resp.data, "re", productPosts);
        } else {
          toast.show({
            render: () => <Toast color="red" message={resp.data?.status_msg || "Failed"} />,
            placement: "top",
          });
        }
      } catch (error) {
        console.log("API error:", error);
        toast.show({
          render: () => <Toast color="red" message="Something went wrong" />,
          placement: "top",
        });
      }
      finally {
        setIsLoadingMore(false);
        setIsLoadingProducts(false); 
      }
    };
    const loadMorePosts = () => {
      if (hasMorePosts && !isLoadingMore) {
        submitSelectedCategories(currentPage,false);
        
      }
    };
    const getInvitedFriends = async () => {
      try {
        const resp = await axios.get(
          `${GlobalConstants.townTicksBaseUrl}friend/invited`
        );
        if (resp.data.status) {
          setInvitedFriends(resp.data.data);
          console.log("data",resp.data.data)
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={"Failed to get Invited Friends!!!"}
                />
              );
            },
            placement: "top",
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    const getCategoriesForProduct = async () => {
      try {
        const response = await axios.get(`${GlobalConstants.townTicksBaseUrl}/products/category`);
        if (response.data?.status) {
          // Set category names for checkboxes
          setCategories(response.data.data);
          // console.log("categories",response.data.data)
          // Optional: keep full data for subcategories
          setFullCategoriesData(response.data.data);
        }
      } catch (error) {
        console.log("Category fetch error:", error);
      }
    };
    

    useEffect(() => {
      const init = async () => {
        changeColor("");
        await getSettings();
        await getFriends();
        await getAllBusinessCategories(isBrand);
        LoadFonts();
        
        const action = route?.params?.action;
        const payload = route?.params?.payload;
    
        if (action && payload) {
          // When coming from a button → skip default
          switch (action) {
            case "deals":
              await feedsFirstPage(payload);
              changeColor("Deals");
              setActiveButton("Deals");
              setTextModeForEditor("Share important deals with your friends and family, on TownTicks.")
              break;
            case "ads":
              await adsFirstPage(payload);
              changeColor("Ads");
              setActiveButton("Ads");
              setTextModeForEditor("Share important Ads you like with your friends and family, on TownTicks.")
              break;
            case "Products":
              await handleProductView();
              changeColor("Products");
              setActiveButton("Products");
              setTextModeForEditor("Share Products you like with your friends and family, on TownTicks.")
              break;
            case "openings":
              await feedsFirstPage(payload);
              changeColor("Openings");
              setActiveButton("Openings");
              setTextModeForEditor("Share opening you like with your friends and family, on TownTicks.")
              break;
            case "cityGov":
              await feedsFirstPage(payload);
              changeColor("CityGov");
              setActiveButton("CityGov");
              setTextModeForEditor("Share important Gov Announcements with your friends and family, on TownTicks.")
              break;
            case "cityLens":
              await feedsFirstPage(payload);
              changeColor("cityLens");
              setActiveButton("cityLens");
              setTextModeForEditor("In CityLens, experience your city through the eyes of Influencers.")
              break;  
            case "business":
              await feedsFirstPage(payload);
              changeColor("Business");
              setActiveButton("Business");
              setTextModeForEditor("In future you will only get updates from business that you follow.Share business updates with your friends and family, on TownTicks.");
              break;
            case "events":
              await feedsFirstPage(payload);
              changeColor("Events");
              setActiveButton("Events");
              setTextModeForEditor("Share important events with your friends and family, on TownTicks.")
              break;
            default:
              break;
          }
        } else {
          // Default behavior only runs when no action/payload passed
          await feedsFirstPage(GlobalConstants.feedTypes.cityGovernment.id);
          
          changeColor("CityGov");
        setActiveButton("CityGov");
        }
    
        // Reset the action after handling to avoid re-triggers
        navigation.setParams({});
      };
    
      init();
    }, []);

// const animationRef = useRef(null);
// const direction = useRef(null);
//   const smoothScroll = () => {
//   if (!direction.current) return;

//   const speed = 8; // scrolling speed

//   if (direction.current === "down") {
//     scrollY.current += speed;
//   } else if (direction.current === "up") {
//     scrollY.current = Math.max(0, scrollY.current - speed);
//   }

//   scrollViewRef.current?.scrollTo({
//     y: scrollY.current,
//     animated: false,
//   });

//   animationRef.current = requestAnimationFrame(smoothScroll);
// };

// useEffect(() => {
//   const keyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       direction.current = "down";

//       if (!animationRef.current) {
//         smoothScroll();
//       }
//     }

//     if (e.key === "ArrowUp") {
//       direction.current = "up";

//       if (!animationRef.current) {
//         smoothScroll();
//       }
//     }
//   };

//   const keyUp = (e) => {
//     if (e.key === "ArrowDown" || e.key === "ArrowUp") {
//       direction.current = null;

//       cancelAnimationFrame(animationRef.current);
//       animationRef.current = null;
//     }
//   };

//   window.addEventListener("keydown", keyDown);
//   window.addEventListener("keyup", keyUp);

//   return () => {
//     window.removeEventListener("keydown", keyDown);
//     window.removeEventListener("keyup", keyUp);

//     cancelAnimationFrame(animationRef.current);
//   };
// }, []);

  return (
    <>
    <StatusBar bg="#3700B3" barStyle="light-content" />
      <Center>
        <Box safeAreaTop bg="white" />
        {window?.innerWidth <= 450 ? (
          <HStack
          bg="muted.100"
          px="1"
          py="3"
          justifyContent="space-between"
          alignItems="center"
          w="100%"
          // maxW="900"
        >
          <Center w={[150, 150, 300]}>
            <Pressable
              onPress={() => {
                // window.location.reload();
                navigation.navigate("Home");
              }}
            >
              <HStack alignItems="center">
                <Image
                  source={require("../../../assets/tt_logo.png")}
                  alt="Alternate Text"
                  size="xs"
                />
                {window?.innerWidth > 780 ? (
                  <>
                    <Text style={styles.textWithShadow}>TownTicks</Text>
                  </>
                ) : (
                  <>
                  <Text style={styles.textWithShadowMobile}>TownTicks</Text>
                  </>
                )}
              </HStack>
            </Pressable>
          </Center>
          <Center w={[75, 350, 600]}>
            <Stack
              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
              justifyContent="center"
            >
              {!user ? (
                <Button
                  onPress={() => {
                    changeColor("WhyTownTicks");
                    navigation.navigate("WhyTownTicks");
                  }}
                  colorScheme="primary"
                  size="md"
                  variant="link"
                >
                  <Text
                    w={[75, 150, 150]}
                    color={whyTownTicksColor}
                    fontFamily={GlobalStyles.text.fontFamily}
                    fontSize={"lg"}
                    fontWeight="bold"
                  >
                    Why TownTicks?
                  </Text>
                </Button>
              ) : (
                <>
                 <VStack
                    bg="#F5F5F5"
                    px="1"
                    py="3"
                    justifyContent="space-between"
                    alignItems="center"
                    w="100%"
                    // maxW="900"
                  >
                    {/* <Stack
                      alignItems="center"
                      flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                    > */}
                      
                      
                    {/* </Stack> */}
                 </VStack>
                </>
              )}
            </Stack>
          </Center>

          {/* for header icons */}

          
          <Center w={[75, 150, 300]}>
            <Stack
              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
              justifyContent="center"
              mx={10}
            >
              {!user ? (
                <>
                    <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signInGuestColor}
                    borderColor={signInGuestTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignInGuest");
                      navigation.navigate("SignInGuest");
                    }}
                  >
                    <Text fontWeight="bold" color={signInGuestTextColor}>
                      Guest
                    </Text>
                  </Button>
                  {/* <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={GlobalStyles.colors.white}
                    borderWidth={2}
                    onPress={() => {
                      setModalVisible(!modalVisible);
                    }}
                  >
                    <Text fontWeight="bold" color={GlobalStyles.colors.white}>
                      Contact Us
                    </Text>
                  </Button> */}
                  <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signUpColor}
                    borderColor={signUpTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignUp");
                      navigation.navigate("SignUp");
                    }}
                  >
                    <Text fontWeight="bold" color={signUpTextColor}>
                      Sign Up
                    </Text>
                  </Button>
                  <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signInColor}
                    borderColor={signInTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignIn");
                      navigation.navigate("SignIn");
                    }}
                  >
                    <Text fontWeight="bold" color={signInTextColor}>
                      Log In
                    </Text>
                  </Button>
                </>
              ) : (
                <>
                  <Menu
                    w="190"
                    placement={"bottom right"}
                    trigger={(triggerProps) => {
                      return (
                        <Pressable
                          accessibilityLabel="More options menu"
                          {...triggerProps}
                        >
                          <Image source={require("../../../assets/side-bar-icons/gg_menu-grid-r.png")} alt="card-icon" size="40px"/>
                          {/* <HamburgerIcon size="md" mt={2} /> */}
                          {/* <Avatar
                            size="sm"
                            source={{
                              uri: GlobalConstants.notFoundImageUrl,
                            }}
                            bg={GlobalStyles.colors.blue}
                          >
                            {getAvatarChar(user.email)}
                          </Avatar> */}
                        </Pressable>
                      );
                    }}
                  >
                    <Menu.Item isDisabled>
                      <Text
                        fontWeight="bold"
                        fontFamily={GlobalStyles.text.fontFamily}
                        color={GlobalStyles.colors.blue}
                      >
                        {user.profile ? user.profile.name : user.email}
                      </Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        changeColor("Settings");
                        navigation.navigate("Settings");
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Settings</Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        setModalVisible(!modalVisible);
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Contact Us</Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        dispatch(SetUser.action(null));
                        navigation.navigate("Home");
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Logout</Text>
                    </Menu.Item>
                  </Menu>
                </>
              )}
            </Stack>
          </Center>
        </HStack>
        ):(
          <HStack
          bg="muted.100"
          px="1"
          py="1"
          justifyContent="space-between"
          alignItems="center"
          w="100%"
          // maxW="900"
        >
          <Center w={[150, 150, 250]}>
            <Pressable
              onPress={() => {
                // window.location.reload();
                navigation.navigate("Home");
              }}
            >
              <HStack alignItems="center">
                <Image
                  source={require("../../../assets/tt_logo.png")}
                  alt="Alternate Text"
                  size="xs"
                />
                {window?.innerWidth > 780 ? (
                  <>
                    <Text style={styles.textWithShadow}>TownTicks</Text>
                  </>
                ) : (
                  <>
                  <Text style={styles.textWithShadowMobile}>TownTicks</Text>
                  </>
                )}
              </HStack>
            </Pressable>
          </Center>
          <Center w={[75, 350, 700]}>
            <Stack
              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
              justifyContent="center"
            >
              {!user ? (
                <Button
                  onPress={() => {
                    changeColor("WhyTownTicks");
                    navigation.navigate("WhyTownTicks");
                  }}
                  colorScheme="primary"
                  size="md"
                  variant="link"
                >
                  <Text
                    w={[75, 150, 150]}
                    color={whyTownTicksColor}
                    fontFamily={GlobalStyles.text.fontFamily}
                    fontSize={"lg"}
                    fontWeight="bold"
                  >
                    Why TownTicks?
                  </Text>
                </Button>
              ) : (
                <>
                 <VStack
                    bg="#F5F5F5"
                    px="1"
                    py="3"
                    justifyContent="space-between"
                    alignItems="center"
                    w="100%"
                    // maxW="900"
                  >
                    {/* <Stack
                      alignItems="center"
                      flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                    > */}
                      <Stack
                        w={[350, 450, 600]}
                        justifyContent="space-between"
                        flexDirection={"row"}
                      >
                        <Button
                          size={"sm"}
                          variant={"solid"}
                          mt="2"
                          mx="1"
                          px="2"
                          bg={GlobalStyles.colors.sideButton}
                          // borderColor={cityGovBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          
                          onPress={() => {
                            changeColor("CityGov");
                            setActiveButton("CityGov");
                            setTextModeForEditor("Share important Gov Announcements with your friends and family, on TownTicks.")
                            feedsFirstPage(GlobalConstants.feedTypes.cityGovernment.id);
                          }}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                              source={require("../../../assets/side-bar-icons/cityGov.png")}
                              alt="Openings Icon"
                              size="7"
                              resizeMode="contain"
                            />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "CityGov" ? "bold" : "400"}
                              textDecorationLine={activeButton === "CityGov" ? "underline" : "none"}
                              fontFamily={GlobalStyles.text.fontFamily}
                              color={cityGovBtnTextColor}
                            >
                              City Gov
                            </Text>
                          </VStack>
                        
                        </Button>
                        <Button
                          size={"sm"}
                          variant={"solid"}
                          mt="2"
                          mx="1"
                          px="2"
                          bg={GlobalStyles.colors.sideButton}
                          // borderColor={businessBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          onPress={() => {
                            changeColor("Business");
                            setActiveButton("Business");
                            setTextModeForEditor("In future you will only get updates from business that you follow.Share business updates with your friends and family, on TownTicks.");
                            feedsFirstPage(GlobalConstants.feedTypes.business.id);
                          }}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                              source={require("../../../assets/side-bar-icons/Busines.png")}
                              alt="Openings Icon"
                              size="7"
                              resizeMode="contain"
                            />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "Business" ? "bold" : "400"}
                              textDecorationLine={activeButton === "Business" ? "underline" : "none"}
                              fontFamily={GlobalStyles.text.fontFamily}
                              color={businessBtnTextColor}
                            >
                              Business Updates
                            </Text>
                          </VStack>
                          
                        </Button>
                        
                        <Button
                          size={"sm"}
                          variant={"solid"}
                          mt="2"
                          mx="1"
                          px="2"
                          bg={GlobalStyles.colors.sideButton}
                          // borderColor={eventsBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          onPress={() => {
                            changeColor("Events");
                            setActiveButton("Events");
                            setTextModeForEditor("Share important events with your friends and family, on TownTicks.")
                            feedsFirstPage(GlobalConstants.feedTypes.events.id);
                          }}
                          isDisabled={isEventsEnabled ? false : true}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                              source={require("../../../assets/side-bar-icons/events.png")}
                              alt="Openings Icon"
                              size="7"
                              resizeMode="contain"
                            />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "Events" ? "bold" : "400"}
                              textDecorationLine={activeButton === "Events" ? "underline" : "none"}
                              fontFamily={GlobalStyles.text.fontFamily}
                              color={eventsBtnTextColor}
                            >
                              Events
                            </Text>
                          </VStack>
                        </Button>
                        <Button
                          size="sm"
                          variant="solid"
                          mt="2"
                          mx="1"
                          px="3"
                          py="3"
                          bg={GlobalStyles.colors.sideButton}
                          // borderColor={openingsBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          onPress={() => {
                            changeColor("Openings");
                            setActiveButton("Openings");
                            setTextModeForEditor("Share opening you like with your friends and family, on TownTicks.")
                            feedsFirstPage(GlobalConstants.feedTypes.openings.id);
                          }}
                          isDisabled={!isOpeningsEnabled}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                              source={require("../../../assets/side-bar-icons/openings.png")}
                              alt="Openings Icon"
                              size="7"
                              resizeMode="contain"
                            />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "Openings" ? "bold" : "400"}
                              textDecorationLine={activeButton === "Openings" ? "underline" : "none"}
                              color={openingsBtnTextColor}
                            >
                              Openings
                            </Text>
                          </VStack>
                        </Button>
                        <Button
                          size={"sm"}
                          variant={"solid"}
                          mt="2"
                          mx="1"
                          px="2"
                          bg={GlobalStyles.colors.sideButton}
                          // borderColor={dealsBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          
                          onPress={() => {
                            changeColor("Deals");
                            setActiveButton("Deals");
                            setTextModeForEditor("Share important deals with your friends and family, on TownTicks.")
                            feedsFirstPage(GlobalConstants.feedTypes.deals.id);
                          }}
                          isDisabled={isDealsEnabled ? false : true}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                                source={require("../../../assets/side-bar-icons/deals.png")}
                                alt="Alternate Text"
                                size="7"
                                resizeMode="contain"
                              />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "Deals" ? "bold" : "400"}
                              textDecorationLine={activeButton === "Deals" ? "underline" : "none"}
                              fontFamily={GlobalStyles.text.fontFamily}
                              color={dealsBtnTextColor} >
                              Deals
                            </Text>
                          </VStack>
                          
                        </Button>
                        <Button
                          // isDisabled={true}
                          size={"sm"}
                          variant={"solid"}
                          mt="2"
                          mx="1"
                          px="2"
                          bg={GlobalStyles.colors.sideButton}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          // borderColor={dealsBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          
                          onPress={() => {
                            changeColor("Products");
                            setActiveButton("Products");
                            setTextModeForEditor("Share Products you like with your friends and family, on TownTicks.")
                            // setAdType(1);
                            // adsFirstPage(1);
                            handleProductView();
                          }}
                          isDisabled={isDealsEnabled ? false : true}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                                source={require("../../../assets/product.png")}
                                alt="Alternate Text"
                                size="7"
                                resizeMode="contain"
                              />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "Products" ? "bold" : "400"}
                              textDecorationLine={activeButton === "Products" ? "underline" : "none"}
                              fontFamily={GlobalStyles.text.fontFamily}
                              color={productsBtnTextColor} >
                              Products
                            </Text>
                          </VStack>
                          
                        </Button>
                        <Button
                          // isDisabled={true}
                          size={"sm"}
                          variant={"solid"}
                          mt="2"
                          mx="1"
                          px="2"
                          
                          bg={GlobalStyles.colors.sideButton}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          // borderColor={dealsBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          
                          onPress={() => {
                            changeColor("cityLens");
                            setActiveButton("cityLens");
                            setTextModeForEditor("In CityLens, experience your city through the eyes of Influencers.")
                            // setAdType(1);
                            feedsFirstPage(GlobalConstants.feedTypes.cityLens.id);
                          }}
                          // isDisabled={isDealsEnabled ? false : true}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                                source={require("../../../assets/side-bar-icons/citylens.png")}
                                alt="Alternate Text"
                                size="7"
                                resizeMode="contain"
                              />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "cityLens" ? "bold" : "400"}
                              textDecorationLine={activeButton === "cityLens" ? "underline" : "none"}
                              fontFamily={GlobalStyles.text.fontFamily}
                              color={cityLensBtnTextColor} >
                              City Lens
                            </Text>
                          </VStack>
                          
                        </Button>
                        <Button
                          // isDisabled={true}
                          size={"sm"}
                          variant={"solid"}
                          mt="2"
                          mx="1"
                          px="2"
                          bg={GlobalStyles.colors.sideButton}
                          _hover={{ bg: GlobalStyles.colors.grey }} 
                          // borderColor={dealsBtnTextColor}
                          // borderWidth={1}
                          // borderRadius={10}
                          
                          onPress={() => {
                            changeColor("Ads");
                            setActiveButton("Ads");
                            setTextModeForEditor("Share important Ads you like with your friends and family, on TownTicks.")
                            setAdType(1);
                            adsFirstPage(1);
                          }}
                          isDisabled={isDealsEnabled ? false : true}
                        >
                          <VStack alignItems="center" space={1}>  
                            <Image
                                source={require("../../../assets/side-bar-icons/Ads.png")}
                                alt="Alternate Text"
                                size="7"
                                resizeMode="contain"
                              />
                            <Text
                              fontSize="12px"
                              fontWeight={activeButton === "Ads" ? "bold" : "400"}
                              textDecorationLine={activeButton === "Ads" ? "underline" : "none"}
                              fontFamily={GlobalStyles.text.fontFamily}
                              color={adsBtnTextColor} >
                              Ads
                            </Text>
                          </VStack>
                          
                        </Button>
                      </Stack>
                      
                    {/* </Stack> */}
                 </VStack>
                </>
              )}
            </Stack>
          </Center>

          {/* for header icons */}

          
          <Center w={[75, 150, 250]}>
            <Stack
              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
              justifyContent="center"
              mx={10}
            >
              {!user ? (
                <>
                    <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signInGuestColor}
                    borderColor={signInGuestTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignInGuest");
                      navigation.navigate("SignInGuest");
                    }}
                  >
                    <Text fontWeight="bold" color={signInGuestTextColor}>
                      Guest
                    </Text>
                  </Button>
                  {/* <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={GlobalStyles.colors.white}
                    borderWidth={2}
                    onPress={() => {
                      setModalVisible(!modalVisible);
                    }}
                  >
                    <Text fontWeight="bold" color={GlobalStyles.colors.white}>
                      Contact Us
                    </Text>
                  </Button> */}
                  <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signUpColor}
                    borderColor={signUpTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignUp");
                      navigation.navigate("SignUp");
                    }}
                  >
                    <Text fontWeight="bold" color={signUpTextColor}>
                      Sign Up
                    </Text>
                  </Button>
                  <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signInColor}
                    borderColor={signInTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignIn");
                      navigation.navigate("SignIn");
                    }}
                  >
                    <Text fontWeight="bold" color={signInTextColor}>
                      Log In
                    </Text>
                  </Button>
                </>
              ) : (
                <>
                  <Menu
                    w="190"
                    placement={"bottom right"}
                    trigger={(triggerProps) => {
                      return (
                        <Pressable
                          accessibilityLabel="More options menu"
                          {...triggerProps}
                        >
                          <Image source={require("../../../assets/side-bar-icons/gg_menu-grid-r.png")} alt="card-icon" size="40px"/>
                          {/* <HamburgerIcon size="md" mt={2} /> */}
                          {/* <Avatar
                            size="sm"
                            source={{
                              uri: GlobalConstants.notFoundImageUrl,
                            }}
                            bg={GlobalStyles.colors.blue}
                          >
                            {getAvatarChar(user.email)}
                          </Avatar> */}
                        </Pressable>
                      );
                    }}
                  >
                    <Menu.Item isDisabled>
                      <Text
                        fontWeight="bold"
                        fontFamily={GlobalStyles.text.fontFamily}
                        color={GlobalStyles.colors.blue}
                      >
                        {user.profile ? user.profile.name : user.email}
                      </Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        changeColor("Settings");
                        navigation.navigate("Settings");
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Settings</Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        setModalVisible(!modalVisible);
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Contact Us</Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        dispatch(SetUser.action(null));
                        navigation.navigate("Home");
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Logout</Text>
                    </Menu.Item>
                  </Menu>
                </>
              )}
            </Stack>
          </Center>
        </HStack>
        )}
        
        <Divider bg={GlobalStyles.colors.mustard} w="100%" />
      </Center>
      
      <ScrollView ref={scrollViewRef} onScroll={handleScroll}
        scrollEventThrottle={16}
        // keyboardScrolling={true}
        enableArrowKeys={true}
        style={{ flex: 1 }}
        contentContainerStyle={{ flexGrow: 1 }}

        >
        <Center>
          {/* <Box safeAreaTop bg="white" /> */}
          
          <VStack
            bg="#F5F5F5"
            px="1"
            py="3"
            justifyContent="space-between"
            alignItems="center"
            w="100%"
            // maxW="900"
          >
            {/* <Stack
              alignItems="center"
              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
            > */}
            {window?.innerWidth <= 450 && (
              <ScrollView
                  horizontal
                  showsHorizontalScrollIndicator={false}
                  w="100%"
                >
              <Stack w={[350, 450, 600]} justifyContent="space-between" flexDirection="row">
                {[
                  { name: "CityGov", icon: require("../../../assets/side-bar-icons/cityGov.png"), action: () => feedsFirstPage(GlobalConstants.feedTypes.cityGovernment.id) },
                  { name: "Business Updates", icon: require("../../../assets/side-bar-icons/Busines.png"), action: () => feedsFirstPage(GlobalConstants.feedTypes.business.id) }, 
                  { name: "Events", icon: require("../../../assets/side-bar-icons/events.png"), action: () => feedsFirstPage(GlobalConstants.feedTypes.events.id), disabled: !isEventsEnabled },
                  { name: "Openings", icon: require("../../../assets/side-bar-icons/openings.png"), action: () => feedsFirstPage(GlobalConstants.feedTypes.openings.id), disabled: !isOpeningsEnabled },
                  { name: "Deals", icon: require("../../../assets/side-bar-icons/deals.png"), action: () => feedsFirstPage(GlobalConstants.feedTypes.deals.id), disabled: !isDealsEnabled },
                  { name: "Products", icon: require("../../../assets/product.png"), action: () => {
                    // setAdType(1);
                    // adsFirstPage(1);
                    handleProductView();
                  }, disabled: "" },
                  { name: "City Lens", icon: require("../../../assets/side-bar-icons/citylens.png"), action: () => feedsFirstPage(GlobalConstants.feedTypes.cityLens.id) },
                  { name: "Ads", icon: require("../../../assets/side-bar-icons/Ads.png"), action: () => {
                    setAdType(1);
                    adsFirstPage(1);
                  }, disabled: "" },
                ].map((item, index) => (
                  <Button
                    key={index}
                    size="sm"
                    variant="solid"
                    mt="2"
                    mx="1"
                    px="2"
                    bg={GlobalStyles.colors.sideButton}
                    _hover={{ bg: GlobalStyles.colors.grey }} 
                    onPress={() => {
                      setTopActiveButton(item.name);
                      setSubActiveButton("");
                      item.action();
                    }}
                    isDisabled={item.disabled}
                  >
                    <VStack alignItems="center">
                      <Image source={item.icon} alt={`${item.name} Icon`} size="6" />
                      <Text
                              fontSize="10px"
                              fontWeight="400"
                              
                              fontFamily={GlobalStyles.text.fontFamily}
                            
                            >
                              {item.name}
                      </Text>
                      {topActiveButton === item.name && (
                        <Box width="30px" height="2px" bg={GlobalStyles.colors.mustard} mt="1" />
                      )}
                    </VStack>
                  </Button>
                ))}
              </Stack>
              </ScrollView>
            )}
            
              
              
            {/* </Stack> */}
          </VStack>

          <HStack
            bg="#F5F5F5"
            justifyContent="space-between"
            w="100%"
            // maxW="900"
          >
            {window?.innerWidth >= 415 && (
              <HStack
              bg="#F5F5F5"
              justifyContent="space-between"
              flex={1}
              w="100%"
              maxW={[
                user.user_category == GlobalConstants.userCategories.citizen.id
                  ? 75
                  : 0,
                130,
                250,
              ]}
            >
              {user.user_category ==
                GlobalConstants.userCategories.citizen.id && (
                <VStack>
                      <Box
                      // bg="gray.900"
                      color="white"
                      h="80vh"
                      w="250px"
                      position="sticky"
                      left={0}
                      top={2}
                      p={4}
                      boxShadow="lg"
                    >
                        

                      {/* Menu Items */}
                      <VStack spacing={8} >
                        {menuItems.map((item) => (
                          <Box key={item.name} position="relative" w="100%">
                            {item.name === "Friend's Shares" & shareCount >0 ? (
                              
                              <Box
                                position="absolute"
                                top="6px"
                                right="0px"
                                w="20px"
                                h="20px"
                                bg="blue.500"
                                borderRadius="full"
                                borderWidth="2px"
                                justifyContent="center"
                                alignItems="center"
                                borderColor={GlobalStyles.colors.sideButton}
                                zIndex={1}
                              >
                                <Text
                                    color="white"
                                    fontSize="10px"
                                    fontWeight="bold"
                                    textAlign="center"
                                  >
                                    {shareCount}
                                  </Text>
                                
                              </Box>
                            ):null}
                          <Button
                            key={item.name}
                            w="100%"
                            size="sm"
                            variant="solid"
                            mt="3"
                            mx={5}
                            justifyContent="stretch"
                            _hover={{ bg: GlobalStyles.colors.grey }} 
                            bg={ GlobalStyles.colors.sideButton}
                            onPress={() => handlePress(item.name, item.action)}
                            leftIcon={
                              <Image source={item.icon} alt={`${item.name} Icon`} size="7" mr="6" />
                            }
                          >
                            <Text
                              fontSize={"16px"}
                            fontWeight={"500"}
                            fontFamily={GlobalStyles.text.fontFamily}
                            color={subActiveButton === item.name ? GlobalStyles.colors.mustard : GlobalStyles.colors.black}
                            >
                              {item.name}
                            </Text>
                          </Button>
                          </Box>
                        ))}
                      </VStack>
                      </Box>
                </VStack>
              )}
            </HStack>
            )}
            
            <HStack
              bg="#F5F5F5"
              justifyContent="space-between"
              // w="75%"
              // style={{ display: window?.innerWidth > 450 ? 'block' : 'flex', }}
              flex={3}
              maxW={[320, 440, 640]}
               pl={{ base: "70px", md: "0px" }}
              // minW={0}
              justifyContent="center"
              // style={{
              //   paddingLeft: "clamp(20px, 5vw, 120px)",
              // }}
            >
              <VStack>
                {isShowEventsText ? (
                  <>
                    <Stack w={[300, 450, 610]} alignItems="center">
                      <Text
                        // alignSelf={"flex-start"}
                        fontFamily={"Petemoss"}
                        fontSize={40}
                        // fontWeight={"bold"}
                        color={GlobalStyles.colors.blue}
                      >
                        Upcoming Events
                      </Text>
                    </Stack>
                  </>
                ) : (
                  <></>
                )}
                { adType >= 1 ? (
                  <>
                 
                  <HStack
                  space={2}
                  justifyContent="center"
                  flexWrap="wrap"
                  display={["none", "none", isAdsEnable ? "flex" : "none"]} // Only show on md and up (desktop)
                >
                  {buttonData.map(({ label, icon, id }, index) => (
                    <Button
                    key={index}
                    w="15%"
                    bg={GlobalStyles.colors.blue}
                    borderWidth="1px"
                    borderColor={
                      selectedIndexAd === index
                        ? GlobalStyles.colors.mustard
                        : "transparent"
                    }
                    onPress={() => {
                      setSelectedIndexAd(index);
                      adsFirstPage(id);
                    }}
                  >
                    <VStack alignItems="center" space={1}>
                      <Image
                        source={{ uri: icon }}
                        alt={label}
                        size="4"
                        resizeMode="contain"
                      />
                      <Text
                        fontSize="12px"
                        fontWeight="500"
                        color={
                          selectedIndexAd === index
                            ? GlobalStyles.colors.mustard
                            : GlobalStyles.colors.white
                        }
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {label}
                      </Text>
                    </VStack>
                  </Button>
                  ))}
                </HStack>
                <VStack
                  space={2}
                  alignItems="center"
                  display={[isAdsEnable ? "flex" : "none", isAdsEnable ? "flex" : "none", "none"]} // Show only on mobile screens
                >
                  <HStack space={2} justifyContent="center">
                    {buttonData.slice(0, 3).map(({ label, icon, id }, index) => (
                      <Button
                        key={index}
                        w="30%"
                        bg={GlobalStyles.colors.blue}
                        borderWidth="1px"
                        borderColor={
                          selectedIndexAd === index
                            ? GlobalStyles.colors.mustard
                            : "transparent"
                        }
                        onPress={() => {
                          setSelectedIndexAd(index);
                          adsFirstPage(id);
                        }}
                        leftIcon={
                          <Image
                            source={{ uri: icon }}
                            alt={label}
                            size="4"
                            resizeMode="contain"
                          />
                        }
                      >
                        <Text
                          fontSize="9px"
                          fontWeight="500"
                          color={
                            selectedIndexAd === index
                              ? GlobalStyles.colors.mustard
                              : GlobalStyles.colors.white
                          }
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {label}
                        </Text>
                      </Button>
                    ))}
                  </HStack>
                
                  <HStack space={2} justifyContent="center">
                    {buttonData.slice(3, 6).map(({ label, icon, id }, i) => {
                      const index = i + 3; // Adjust index for second row
                      return (
                        <Button
                          key={index}
                          w="30%"
                          bg={GlobalStyles.colors.blue}
                          borderWidth="1px"
                          borderColor={
                            selectedIndexAd === index
                              ? GlobalStyles.colors.mustard
                              : "transparent"
                          }
                          onPress={() => {
                            setSelectedIndexAd(index);
                            adsFirstPage(id);
                          }}
                          leftIcon={
                            <Image
                              source={{ uri: icon }}
                              alt={label}
                              size="4"
                              resizeMode="contain"
                            />
                          }
                        >
                          <Text
                            fontSize="9px"
                            fontWeight="500"
                            color={
                              selectedIndexAd === index
                                ? GlobalStyles.colors.mustard
                                : GlobalStyles.colors.white
                            }
                            fontFamily={GlobalStyles.text.fontFamily}
                          >
                            {label}
                          </Text>
                        </Button>
                      );
                    })}
                  </HStack>
                </VStack>
                </>
                ):null}
                {isLoading ? (
                    <Stack w={[300, 450, 610]} alignItems="center">
                      <Spinner
                        color={GlobalStyles.colors.mustard}
                        m={10}
                        size="lg"
                        accessibilityLabel="Loading posts"
                      />
                    </Stack>
                  ) : isAdsEnable ? (
                    <>
                    {ticks.length > 0 ?( window?.innerWidth >= 415 ? (
                      <ScrollView w={[260, 360, 610]} showsVerticalScrollIndicator={false}>
                        <VStack alignItems="center">
                          <Stack
                            justifyContent="center"
                            flexDirection="row"
                            space={3}
                            flexWrap="wrap"
                            m={1}
                          >
                            {ticks.map((x, index) => (
                              <AdCardForCitizen
                                key={index}
                                data={x}
                                setSelectedPost={onClick}
                                friends={friends}
                              />
                            ))}
                          </Stack>

                          {!isSavedFeeds && !isShareFeeds && showLoadMore && (
                            <Button
                              my={5}
                              isLoading={isLoadMoreLoading}
                              size="sm"
                              variant="outline"
                              onPress={adsNextPage}
                            >
                              Load More
                            </Button>
                          )}
                        </VStack>
                      </ScrollView>
                    ) : (
                      <ScrollView
                        style={{ flex: 1 }}
                        w="100%"
                        showsVerticalScrollIndicator={false}
                        contentContainerStyle={{
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <VStack w="100%" alignItems="center">
                          <Stack
                            justifyContent="center"
                            flexDirection="column"
                            space={3}
                            flexWrap="wrap"
                            mx={3}
                            w="100%"
                            mb="20%"
                          >
                            {ticks.map((x, index) => (
                              <AdCardForCitizen
                                key={index}
                                data={x}
                                setSelectedPost={onClick}
                                friends={friends}
                              />
                            ))}
                          </Stack>

                          {!isSavedFeeds && !isShareFeeds && showLoadMore && (
                            <Button
                              position="relative"
                              bottom="60px"
                              isLoading={isLoadMoreLoading}
                              size="sm"
                              variant="outline"
                              onPress={adsNextPage}
                            >
                              Load More
                            </Button>
                          )}
                        </VStack>
                      </ScrollView>
                    )
                  ) : null}
                    </>
                  ) : ticks.length > 0 ? (
                    window?.innerWidth >= 415 ? (
                      <ScrollView w={[260, 360, 610]} showsVerticalScrollIndicator={false}>
                        <VStack alignItems="center">
                          <Stack
                            justifyContent="center"
                            flexDirection="row"
                            space={3}
                            flexWrap="wrap"
                            m={1}
                          >
                            {ticks.map((x, index) => (
                              <FeedCardForCitizen 
                                key={index}
                                data={x}
                                setSelectedPost={onClick}
                                friends={friends}
                              />
                            ))}
                          </Stack>

                          {!isSavedFeeds && !isShareFeeds && showLoadMore && (
                            <Button
                              my={5}
                              isLoading={isLoadMoreLoading}
                              size="sm"
                              variant="outline"
                              onPress={feedsNextPage}
                            >
                              Load More
                            </Button>
                          )}
                        </VStack>
                      </ScrollView>
                    ) : (
                      <ScrollView
                        style={{ flex: 1 }}
                        w="100%"
                        showsVerticalScrollIndicator={false}
                        contentContainerStyle={{
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <VStack w="100%" alignItems="center">
                          <Stack
                            justifyContent="center"
                            flexDirection="column"
                            space={3}
                            flexWrap="wrap"
                            mx={3}
                            w="100%"
                            mb="20%"
                          >
                            {ticks.map((x, index) => (
                              <FeedCardForCitizen
                                key={index}
                                data={x}
                                setSelectedPost={onClick}
                                friends={friends}
                              />
                            ))}
                          </Stack>

                          {!isSavedFeeds && !isShareFeeds && showLoadMore && (
                            <Button
                              position="relative"
                              bottom="60px"
                              isLoading={isLoadMoreLoading}
                              size="sm"
                              variant="outline"
                              onPress={feedsNextPage}
                            >
                              Load More
                            </Button>
                          )}
                        </VStack>
                      </ScrollView>
                    )
                  ) : null}
                {isFollowedBusinessSelected ? (
                   <Center w="100%">
                      <Box w={[320, 400, 600]} ml={ window?.innerWidth > 450 ? 0 : 5}> 
                        <Heading fontSize="sm" p="4" pb="3" textAlign="center">
                          Search & Follow Business In Your City
                        </Heading>
                        <HStack space={4} justifyContent="center" mt={4}>
                    <Button  
                          w={["20%", "25%", "30%"]}
                          bg={GlobalStyles.colors.blue}
                          borderWidth="1px"
                          borderColor={
                            isBrand == "LOCAL"
                            ? GlobalStyles.colors.mustard
                            : "transparent"
                          } 
                          onPress={async () => {
                            setTimeout(() => {
                              setSelectedSubCategories([]);
                              setSelectedCategories([]);

                              setCategoryKey(`category-${Date.now()}`);
                              setSubCategoryKey(`sub-category-${Date.now()}`);

                              setShowSelects(true); // remounts them
                            }, 10);
                            await getAllBusinessCategories("LOCAL");
                            await unfollowBusinessesPage1("LOCAL");
                            
                           
                          }}
                          >
                      <Text
                      fontSize={["12px", "14px", "16px"]}
                      fontWeight="500"
                      color={
                         isBrand == "LOCAL"
                         ? GlobalStyles.colors.mustard 
                         : GlobalStyles.colors.white
                      }
                      fontFamily={GlobalStyles.text.fontFamily}
                      >Local</Text>
                    </Button>
                    <Button  
                          w={["25%", "30%", "30%"]}
                          bg={GlobalStyles.colors.blue}
                          borderWidth="1px"
                          borderColor={
                            isBrand == "INTERNATIONAL"
                            ? GlobalStyles.colors.mustard
                            : "transparent"
                          }  
                          onPress={async () => {
                            setTimeout(() => {
                              setSelectedSubCategories([]);
                              setSelectedCategories([]);

                              setCategoryKey(`category-${Date.now()}`);
                              setSubCategoryKey(`sub-category-${Date.now()}`);

                              setShowSelects(true); // remounts them
                            }, 10);
                            await getAllBusinessCategories("INTERNATIONAL");
                            await unfollowBusinessesPage1("INTERNATIONAL");
                            
                            
                          }}
                          >
                      <Text
                      fontSize={["12px", "14px", "16px"]}
                      fontWeight="500"
                      color={
                        
                        isBrand == "INTERNATIONAL"
                        ? GlobalStyles.colors.mustard 
                        : GlobalStyles.colors.white
                      }
                      fontFamily={GlobalStyles.text.fontFamily}
                      >International</Text>
                    </Button>
                  </HStack>
                        <Center>
                          <Input
                            w={[250, 350, 350]}
                            placeholder="Search ..."
                            variant="filled"
                            borderRadius="10"
                            mt="1"
                            py="1"
                            px="2"
                            InputLeftElement={
                              <Icon
                                ml="2"
                                size="4"
                                color="gray.400"
                                as={<Ionicons name="ios-search" />}
                              />
                            }
                            onChangeText={onSearchTextChange}
                          />
                          <Text w={[250, 350, 350]}>
                            {noSearchBusinessResultText}
                          </Text>
                    {showSelects && (
                      <> 
                       {isBrand === "LOCAL" && (    
                          <Select
                          key={categoryKey}
                            w={[250, 350, 350]}
                            accessibilityLabel="Select Business Category"
                            placeholder="Select Business Category"
                            _selectedItem={{
                              bg: "teal.600",
                            }}
                            mt="1"
                            borderRadius="10"
                            onValueChange={(x) => {
                              getAllBusinessSubCategoriesById(x);
                              setSelectedCategories(x);
                            }}
                            selectedValue={selectedCategory}
                          >
                            {businessCategories.map((x, index) => {
                              return (
                                <Select.Item
                                  key={index}
                                  label={x.title.toString()}
                                  value={x.id.toString()}
                                />
                              );
                            })}
                          </Select>
                            )
                          }
                          <Select
                          key={subCategoryKey}
                            w={[250, 350, 350]}
                            accessibilityLabel="Select Business Sub Category"
                            placeholder={
                              isBrand === "INTERNATIONAL"
                                ? "Select Business Category"
                                : "Select Business Sub Category"
                            }
                            _selectedItem={{
                              bg: "teal.600",
                            }}
                            mt="1"
                            borderRadius="10"
                            onValueChange={(x) => {
                              OnChangeSubCategoryGetUnfollowedBusiness(x);
                              setSelectedSubCategories(x);
                            }}
                            selectedValue={selectedSubCategory}
                          >
                            {businessSubCategories.map((x, index) => {
                              return (
                                <Select.Item
                                  key={index}
                                  label={x.title.toString()}
                                  value={x.id.toString()}
                                />
                              );
                            })}
                          </Select>
                          </>
                    )}
                        </Center>
                       <Box mt={1} h="310px">
                      <FlatList
                        extraData={businessSelectedId}
                        data={unfollowBusinesses}
                        renderItem={({ item }) => (
                          <Box
                            borderBottomWidth="1"
                            _dark={{
                              borderColor: "muted.50",
                            }}
                            borderColor="muted.300"
                            pl={["0", "4"]}
                            pr={["0", "5"]}
                            py="2"
                          >
                            <HStack space={[2, 3]} justifyContent="space-between">
                              <Avatar
                                size="sm"
                                source={{
                                  uri: item.logo_url,
                                }}
                                bg={GlobalStyles.colors.blue}
                              >
                                {item.business_profile
                                  ? getAvatarChar(item.business_profile?.name)
                                  : ""}
                              </Avatar>
                              <VStack>
                                <Text
                                  _dark={{
                                    color: "warmGray.50",
                                  }}
                                  color="coolGray.800"
                                  // numberOfLines={2}
                                  bold
                                >
                                  {window?.innerWidth < 415 &&
                                  item.business_profile &&
                                  item.business_profile?.name
                                    ? item.business_profile?.name?.split(" ")[0] +
                                      // " " +
                                      // item.business_profile?.name
                                      //   ?.split(" ")[1]
                                      //   .substring(0, 5) +
                                      "..."
                                    : item.business_profile?.name}
                                </Text>
                              </VStack>
                              <Spacer />
                              <Tooltip label="follow" openDelay={100}>
                                <Button
                                  bg={GlobalStyles.colors.blue}
                                  size={"sm"}
                                  alignSelf="flex-start"
                                  borderRadius={20}
                                  isDisabled
                                  onPress={() => onFollowBusiness(item.id)}
                                >
                                  <Text
                                    fontWeight="bold"
                                    color={GlobalStyles.colors.white}
                                    style={{ textTransform: 'capitalize' }}
                                  >
                                    follow{" "}
                                  </Text>
                                </Button>
                              </Tooltip>
                            </HStack>
                          </Box>
                        )}
                        keyExtractor={(item) => item.id}
                        ListFooterComponent={renderUnfollowBusinessesFooter}
                        
                        
                      />
                  
                       </Box>
                     </Box>
                   </Center>
                ):(
                  <></>
                )}
                {isShowInvite ? (
                  <Center mt={9}>
                   <VStack className="friendSettings" space={4} mt={4}>
                   <Center p={3}>
                     <Text fontSize="sm">
                       Invite Your friends to TownTicks & share Ticks with them.
                     </Text>
                   </Center>
                   <Box w="100%" justifyContent="center" alignItems="center" px={4}>
                   <Center h={110} w={[300, 300, 550]} rounded="md" shadow={3} alignItems="center" >
                     <Image
                       source={require("../../../assets/InviteLogo.png")}
                       alt="Invite"
                       size={50}
                     />
                    <HStack w={[250, 250, 500]} space={3} >
                       <Stack w={[200, 200, 400]}>
                         <FormControl>
                           <Input
                             type="text"
                             onChange={(e) => setInviteEmail(e.target.value)}
                             value={inviteEmail}
                             placeholder="Write Email"
                           />
                         </FormControl>
                       </Stack>
                       <Stack w={[50, 50, 100]}>
                         <FormControl>
                           <Button
                             h={36}
                             size="xs"
                             variant="outline"
                             borderColor="mustard"
                             onPress={SendInvite}
                             isDisabled={isInviteSending} // Disable button while sending
                           >
                             <Text fontFamily="your-font-family" color="blue" fontWeight="bold">
                             {isInviteSending ? 'Sending..' : 'Invite'}
                             </Text>
                           </Button>
                         </FormControl>
                       </Stack>
                     </HStack>
                   </Center>
                   </Box>
                 </VStack>
                 </Center>
                 
                ):(
                  <></>
                )}
                {isShowProducts ?(
                  
                  <VStack px={4} py={8} space={10} bg="#fff" w="100%">

                      {/* ================= TOP TABS ================= */}
                      <HStack justifyContent={ window?.innerWidth > 450 ? "center" : "start"} space={ window?.innerWidth > 450 ? 4 : 2}>
                        <Button
                          bg="#0A1B6F"
                          borderRadius={0}
                          borderColor={activeTab === "popular" ? "#F5A400" : "#0A1B6F"}
                          leftIcon={<Image source={require("../../../assets/popular.png")} alt="Icon" size="5" />}
                          onPress={() => {
                            setActiveTab("popular");
                            getProductByTagId("popular");
                            setIsProductView(true); 
                            
                           }}
                          
                        >
                          <Text color={activeTab === "popular" ? "#F5A400" : "#fff" }>Popular</Text>
                        </Button>
                    
                        <Button
                          bg="#0A1B6F"
                          borderRadius={0}
                          borderColor={activeTab === "new Arrivals" ? "#F5A400" : "#0A1B6F" }
                          leftIcon={<Image source={require("../../../assets/newArrival.png")} alt="Icon" size="5" />}
                          onPress={() => {
                            getProductByTagId("new arrival");
                            setIsProductView(true); 
                            setActiveTab("new Arrivals");
                           }}
                        >
                          <Text color={activeTab === "new Arrivals" ? "#F5A400" : "#fff"}>New Arrivals</Text>
                        </Button>
                    
                        <Button
                          bg="#0A1B6F"
                          borderRadius={0}
                          borderWidth={1}
                          borderColor={activeTab === "settings" ? "#F5A400" : "#0A1B6F"}
                          leftIcon={<Ionicons name="settings-outline" size={16} color="#F5A400" />}
                          onPress={() => {
                           handleShowProducts();
                           setActiveTab("settings");
                          }}
                        >
                          <Text color={activeTab === "settings" ? "#F5A400" : "#fff"}>Settings</Text>
                        </Button>
                      </HStack>
                    
                      {/* ================= MAIN CONTENT ================= */}
                      {isLoadingProducts ? (
                    <Stack w={[300, 450, 610]} alignItems="center">
                      <Spinner
                        color={GlobalStyles.colors.mustard}
                        m={10}
                        size="lg"
                        accessibilityLabel="Loading posts"
                      />
                    </Stack>
                  ):isProductView ? (
                         <>
                         <ScrollView
                           w={[350, 450, 590]}
                           showsVerticalScrollIndicator={false}
                           
                         >
                           <VStack alignItems="center" px={2} mr="10px">
                             <Stack
                               justifyContent="center"
                               flexDirection={"row"}
                               space={3}
                               flexWrap="wrap"
                               m={2}
                             >
                               {productPosts.map((x, index) => {
                                 return (
                                   <AdProductCardForBusiness
                                     data={x}
                                     key={index}
                                     setSelectedPost={onClick}
                                     friends={friends}
                                   />
                                 );
                               })}
                             </Stack>
                           </VStack>
                           {productPosts.length >= 10 && hasMorePosts && (
                           <Stack
                             w={[190, 190, 190]}
                             alignSelf="center"
                             
                           >
                             <Button
                                size="sm"
                                bg={GlobalStyles.colors.blue}
                                onPress={loadMorePosts}
                                isLoading={isLoadingMore} 
                                isLoadingText="Loading..."
                              >
                                <Text
                                  fontWeight="bold"
                                  fontFamily={GlobalStyles.text.fontFamily}
                                  color={GlobalStyles.colors.white}
                                >
                                  Load More
                                </Text>
                              </Button>
                           </Stack>
                          )}
                         </ScrollView>
                           
                         </>
                      ):(
                      <HStack justifyContent="center" space={windowWidth > 450 ? 4 : 2}>
                      {/* LEFT SECTION */}
                      <VStack space={3}>
                        <Text color="#0A1B6F" fontWeight={windowWidth > 450 ? "600" : "400"}>
                          Select Category-Subcategory
                        </Text>

                        <Box
                          width={windowWidth > 450 ? "280px" : "150px"}
                          bg="#fff"
                          px={4}
                          py={5}
                          borderRadius={8}
                          shadow={2}
                        >
                         <VStack space={4}>
                            {categories.map((item) => {
                              const isCategorySelected = selectedCategoryCheck?.id === item.id;

                              return (
                                <VStack key={item.id} space={2}>
                                  {/* CATEGORY */}
                                  <HStack space={3} alignItems="center">
                                    <Checkbox
                                      value={item.name}
                                      // isChecked={isCategorySelected}
                                      onChange={() => handleCheckboxChange("category", item)}
                                      isChecked={item.is_selected}
                                      // isReadOnly  
                                    />
                                    <Text>{item.name}</Text>
                                  </HStack>

                                  {/* SUB-CATEGORIES UNDER SELECTED CATEGORY */}
                                  {isCategorySelected && (
                                    <VStack pl={6} space={3}>
                                      {subCategories.map((subItem) => {
                                        const isChecked =
                                        selectedSubCategoriesCheck.some(
                                          (s) => s.id === subItem.id
                                        );

                                        return (
                                          <HStack key={subItem.id} space={3} alignItems="center">
                                            <Checkbox
                                              value={subItem.name}
                                              // isChecked={isChecked}
                                              isChecked={subItem.is_selected}
                                              isReadOnly
                                              onChange={(checked) =>
                                                handleCheckboxChange(
                                                  "subcategory",
                                                  subItem,
                                                  checked
                                                )
                                              }
                                            />
                                            <Text>{subItem.name}</Text>
                                          </HStack>
                                        );
                                      })}
                                    </VStack>
                                  )}
                                </VStack>
                              );
                            })}
                          </VStack>
                        </Box>
                      </VStack>

                      {/* RIGHT SECTION */}
                      <VStack space={3}>
                        <Text color="#0A1B6F" fontWeight={windowWidth > 450 ? "600" : "400"}>
                          Selected Categories-Subcategories
                        </Text>

                        <Box
                          width={windowWidth > 450 ? "280px" : "150px"}
                          bg="#fff"
                          px={4}
                          py={6}
                          borderRadius={8}
                          shadow={2}
                        >
                          <VStack space={2}>
                            {selectedCombinations.length > 0 ? (
                              selectedCombinations.map((item) => <Text key={item}>{item}</Text>)
                            ) : (
                              <Text color="#999">No selection</Text>
                            )}
                          </VStack>
                        </Box>

                        <Button
                          alignSelf="center"
                          mt={8}
                          px={12}
                          py={3}
                          bg="#0A1B6F"
                          borderRadius={2}
                          isDisabled
                          onPress={() => {
                            submitSelectedCategories();
                            setIsProductView(true); 
                          }}
                        >
                          <Text color="#F5A400" fontWeight="600">
                            Done
                          </Text>
                        </Button>
                      </VStack>
                      </HStack>
                      )}
                   </VStack>
                ):(
                  <></>
                )}
              </VStack>
            </HStack>             
      {window?.innerWidth >= 450 &&(
        <Box
                      // bg="gray.900"
                      color="white"
                      h="80vh"
                      w="250px"
                      position="sticky"
                      // left={0}
                      top={1}
                      pb={2}
                      pr={2}
                      boxShadow="lg"
                    >
              <VStack
              display={{ base: "none", md: "flex" }}   // hide on mobile if needed                                // web 75/25 layout
              // minH="100vh"
              space={8}
              // position="sticky"
              // justifyContent="space-evenly"
              // right="10px"
              // alignItems="center"
              // px={7}
              >
              <HStack
              // bg="#F5F5F5"
              justifyContent="space-between"
              w="100%"
              maxW={[0, 130, 130]}
              // position="sticky"
            >
              <Box style={GlobalStyles.card} position="relative"
                    // right= "170px"
                    height="180px"
                    top= "40px">
              
                    {/* Header */}
                    <Image source={require("../../../assets/side-bar-icons/card.png")} alt="card-icon" size="80px" position="absolute" top="-25px" left="32%" transform="translateX(-50%)"/>
                    <Box style={GlobalStyles.header}  >
                    
                    
                    </Box>  
                    {/* Content */}
                    <Box style={GlobalStyles.content} >
                        <Text style={GlobalStyles.text} lineHeight= "24">
                        We ensure Limited Daily Scrolling. 
                        Saves Your Time. Saves Your Mind.{"\n"}
                        -- Because TownTicks Cares for You.
                        </Text>
                    </Box>
              </Box>
              </HStack>
              <HStack
              // bg="#F5F5F5"
              mt={4}
              justifyContent="space-between"
              w="100%"
              maxW={[0, 130, 130]}
              // position="sticky"
            >
              <Box style={GlobalStyles.card} position="relative"
                    // right= "170px"
                    height="200px"
                    top= "40px">
              
                    {/* Header */}
                    <Image source={require("../../../assets/side-bar-icons/card.png")} alt="card-icon" size="80px" position="absolute" top="-25px" left="32%" transform="translateX(-50%)"/>
                    <Box style={GlobalStyles.header}  >
                    
                    
                    </Box>
                    {/* <Box style={GlobalStyles.content} >
                        <Text style={GlobalStyles.title}>
                        Invite Friends to TownTicks 
                            
                        </Text>
                    </Box> */}
                      
                    {/* Content */}
                    <Box style={GlobalStyles.content}>
                        <Text style={GlobalStyles.text}>
                        {textModeForEditor}
                        </Text>
                    </Box>
              </Box>
              </HStack>
            </VStack>
             </Box>  
            )} 
          </HStack>
        </Center>
      </ScrollView>
      {showUpButton && (<IconButton
        position="absolute"
        bottom={window?.innerWidth > 450 ? 10 : 12}
        right={10}
        borderRadius="full"
        bg={GlobalStyles.colors.blue}
        _pressed={{ bg: "gray.500" }}
        icon={<ChevronUpIcon color="white" size={6} />}
        onPress={scrollToTop}
      />)}
      
      {window?.innerWidth <= 450 &&(
        <VStack
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        bg={GlobalStyles.colors.white}
        py="2"
        borderTopWidth={1}
        borderColor="gray.300"
      >
        <HStack justifyContent="space-between" w="90%" mx="auto">
          {[
            { name: "Saved Ticks", icon: require("../../../assets/side-bar-icons/saved.png"), action: () => getSavedPost()  },
            { name: "Friend's Shares", icon: require("../../../assets/side-bar-icons/shared.png"), action: () => {getSharedPost();getSeenShare();} },
            { name: "Follow Business", icon: require("../../../assets/side-bar-icons/business.png"),  action: () => unfollowBusinessesPage1("LOCAL") },
            { name: "Invite Friends", icon: require("../../../assets/side-bar-icons/inviteFriend.png"), action: () => handleShowInvite() }
          ].map((item, index) => (
            <Button
              key={index}
              variant="unstyled"
              _hover={{ bg: GlobalStyles.colors.grey }} 
              onPress={() => handlePress(item.name, item.action)}
            >
              <VStack alignItems="center">
                <Image source={item.icon} alt={`${item.name} Icon`} size="6" />
                {subActiveButton === item.name && (
                  <Box width="20px" height="2px" bg={GlobalStyles.colors.mustard} mt="1" />
                )}
              </VStack>
            </Button>
          ))}
        </HStack>
        </VStack>
      )}
      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
      >
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Contact Us</Modal.Header>
          <Modal.Body>
            <Text>
              To contact or any feedback about TownTicks, write to
              <Text color={GlobalStyles.colors.blue}>
                {" "}
                support.townticks@novelma.com
              </Text>
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onPress={() => {
                  setModalVisible(false);
                }}
              >
                Close
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default CitizenMainPage;
